import React, { useState } from 'react';
import { Box, Toolbar, CssBaseline, useTheme as useMuiTheme, alpha, Paper } from '@mui/material';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useTheme } from '../theme/ThemeProvider';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { darkMode } = useTheme();
  const muiTheme = useMuiTheme();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <CssBaseline />
      
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} toggleDrawer={toggleSidebar} />
      
      {/* TopBar */}
      <TopBar open={sidebarOpen} />
      
      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3, md: 4 },
          width: `calc(100% - ${sidebarOpen ? 240 : 70}px)`,
          transition: 'all 0.3s ease',
          backgroundColor: muiTheme.palette.background.default,
          minHeight: '100vh',
          boxShadow: 'inset 0 0 50px rgba(0, 0, 0, 0.05)',
          overflowX: 'hidden'
        }}
      >
        <Toolbar sx={{ mb: 1 }} /> {/* This creates space for the fixed AppBar */}
        {children}
      </Box>
    </Box>
  );
};

export default DashboardLayout;
